import { useParams, Navigate } from 'react-router-dom';
import { useRef, useCallback } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { GlobalStyle, PageWrap, Container, TopBar, StatusMsg } from './signup-vendor/styles';
import styled from 'styled-components';
import { useSignupForm } from './signup-vendor/useSignupForm';
import { VenueAgreementForm } from './signup-vendor/VenueAgreementForm';
import { ConfirmationPage, AlreadySubmittedPage } from './signup-vendor/ConfirmationPage';

const Logo = styled.img`
  height: 34px;
  width: auto;
`;


const skipRecaptcha = process.env.REACT_APP_SKIP_RECAPTCHA === 'true';

export const SignupVendorPage = () => {
  const { dealId, vendorId } = useParams();

  const reCaptchaRef = useRef();
  const pageWrapRef = useRef();
  const getRecaptchaToken = useCallback(async () => {
    if (skipRecaptcha) return null;
    const token = await reCaptchaRef.current.executeAsync();
    reCaptchaRef.current.reset();
    return token;
  }, []);

  const form = useSignupForm(dealId, vendorId, getRecaptchaToken, pageWrapRef);
  const { loading, loadError, venueInfo, submitted, f, isAlreadySubmitted } = form;
  const venueShortName = venueInfo?.venueDisplayName?.split(',')[0]?.trim() ?? '';

  if (!dealId || !vendorId) return <Navigate to="/404" replace />;

  return (
    <>
      <GlobalStyle />
      <PageWrap ref={pageWrapRef}>
        <Container>
          <TopBar>
            <Logo src="/best-logo.png" alt="BEST Gift Group" />
          </TopBar>

          {loading && <StatusMsg>Loading…</StatusMsg>}
          {loadError && <StatusMsg>{loadError}</StatusMsg>}

          {!loading && !loadError && isAlreadySubmitted && (
            <AlreadySubmittedPage />
          )}

          {!loading && !loadError && !isAlreadySubmitted && submitted && (
            <ConfirmationPage venueShortName={venueShortName} />
          )}

          {!loading && !loadError && !isAlreadySubmitted && !submitted && f && (
            <VenueAgreementForm {...form} venueInfo={venueInfo} />
          )}
        </Container>
      </PageWrap>
      {!skipRecaptcha && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
          size="invisible"
          ref={reCaptchaRef}
        />
      )}
    </>
  );
};
